import './wdyr'

import React from "react";
import { render } from 'react-dom';
import {App} from './components/App'
//import 'bootstrap/dist/css/bootstrap.min.css';
import './components/App/app.scss'

render(<App />, document.getElementById("root"))
